<template>
  <div>

    <div class="vertical-center">

      <div class="container-fluid col-xs-10 col-sm-10 col-md-12 col-lg-12 col-offset-1">

        <!-- Login Copy -->
        <div class="row">
          <div class="col-md-4 offset-md-4">
            <h3>Password Reset</h3>
            <p>Enter a new password below.</p>
          </div>
        </div>

        <!-- Login Form -->
        <div class="row">
          <div class="col-md-4 offset-md-4">
            <form v-on:submit.prevent="onSubmit">
              <div class="form-group">
                <label for="inputResetPasswordNewPassword">New Password</label>
                <input
                  id="inputResetPasswordNewPassword"
                  class="form-control"
                  type="password"
                  v-model="password"
                  placeholder="Password"
                  required
                />
                <br/>
                <label for="inputResetPasswordNewPasswordConfirmation">New Password Confirmation</label>
                <input
                  id="inputResetPasswordNewPasswordConfirmation"
                  class="form-control"
                  type="password"
                  v-model="password_confirmation"
                  placeholder="Password Confirmation"
                  required
                />
              </div>
              <button type="submit" class="btn btn-primary" v-bind:disabled="(password !== password_confirmation)">Reset Password</button>

              <br>
              <br>

              <p><router-link class="link" :to="{ name: 'Login' }">Log in</router-link></p>
            </form>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import AuthService from '@/common/services/auth.service';

export default {
  name: 'PasswordReset',
  data() {
    return {
      token: this.$route.query.token,
      password: null,
      password_confirmation: null,
      error: null,
    };
  },
  methods: {
    onSubmit() {
      AuthService.reset_password(this.token, this.password, this.password_confirmation)
        .catch((err) => {
          if (err.response && err.response.data) {
            this.$notify({
              type: 'error',
              title: 'Error',
              text: err.response.data.error,
              width: 350,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../styles/views/authentication";
</style>
